import {
    buildErrorsFromMsgs,
    buildErrorsFromResponse
} from '../../../core/js/utils/errorHandling';

export const SAVE_WISHLIST_DATA = 'SAVE_WISHLIST_DATA';
export const UPDATE_WISHLIST_ITEM = 'UPDATE_WISHLIST_ITEM';
export const REMOVE_FROM_WISHLIST_ITEM = 'REMOVE_FROM_WISHLIST_ITEM';
export const REMOVING_WISHLIST_ITEM = 'REMOVING_WISHLIST_ITEM';
export const REMOVED_WISHLIST_ITEM = 'REMOVED_WISHLIST_ITEM';
export const REMOVE_WISHLIST_ITEM_ERROR = 'REMOVE_WISHLIST_ITEM_ERROR';
export const DELETE_WISHLIST = 'DELETE_WISHLIST';
export const WISHLIST_ADD_TO_CART = 'WISHLIST_ADD_TO_CART';
export const EDIT_WISHLIST = 'EDIT_WISHLIST';
export const SUBMIT_DELETE_WISHLIST_ERROR = 'SUBMIT_DELETE_WISHLIST_ERROR';
export const REMOVE_DELETE_WISHLIST_ERROR = 'REMOVE_DELETE_WISHLIST_ERROR';

// Create
export const CREATE_WISHLIST_OPEN = 'CREATE_WISHLIST_OPEN';
export const CREATE_WISHLIST_CLOSE = 'CREATE_WISHLIST_CLOSE';
export const CREATE_WISHLIST_DATA = 'CREATE_WISHLIST_DATA';
export const SUBMIT_CREATE_WISHLIST = 'SUBMIT_CREATE_WISHLIST';
export const SUBMIT_CREATE_WISHLIST_ERROR = 'SUBMIT_CREATE_WISHLIST_ERROR';

// Manage
export const MANAGE_WISHLIST_OPEN = 'MANAGE_WISHLIST_OPEN';
export const MANAGE_WISHLIST_CLOSE = 'MANAGE_WISHLIST_CLOSE';
export const MANAGE_WISHLIST_DATA = 'MANAGE_WISHLIST_DATA';
export const SUBMIT_MANAGE_WISHLIST = 'SUBMIT_MANAGE_WISHLIST';
export const SUBMIT_MANAGE_WISHLIST_ERROR = 'SUBMIT_MANAGE_WISHLIST_ERROR';

// Search
export const SEARCH_WISHLIST_OPEN = 'SEARCH_WISHLIST_OPEN';
export const SEARCH_WISHLIST_CLOSE = 'SEARCH_WISHLIST_CLOSE';
export const SEARCH_WISHLIST_DATA = 'SEARCH_WISHLIST_DATA';
export const SUBMIT_SEARCH_WISHLIST = 'SUBMIT_SEARCH_WISHLIST';
export const SUBMIT_SEARCH_WISHLIST_ERROR = 'SUBMIT_SEARCH_WISHLIST_ERROR';
export const SEARCH_WISHLIST_RESULTS_DATA = 'SEARCH_WISHLIST_RESULTS_DATA';
export const SEARCH_WISHLIST_HIDE_RESULTS = 'SEARCH_WISHLIST_HIDE_RESULTS';
export const NO_FIELDS_HAVE_VALUES_ERROR = 'NO_FIELDS_HAVE_VALUES_ERROR';

export function saveWishlistData(data) {
    return {
        type: SAVE_WISHLIST_DATA,
        payload: data
    };
}

export function updateWishlistItem(e) {
    return {
        type: UPDATE_WISHLIST_ITEM,
        payload: {
            manage: {}
        },
        meta: {
            event: e
        }
    };
}

export function removingWishlistItem(data) {
    return {
        type: REMOVING_WISHLIST_ITEM,
        payload: data
    };
}

export function removedWishlistItem(data) {
    return {
        type: REMOVED_WISHLIST_ITEM,
        payload: data
    };
}

export function removeWishlistItemError(data) {
    return {
        type: REMOVE_WISHLIST_ITEM_ERROR,
        payload: data
    };
}

export function createWishlistData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: CREATE_WISHLIST_DATA,
        payload: {
            create: {
                data: formData,
                msgs: convertedMsgs
            }
        }
    };
}

export function manageWishlistData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: MANAGE_WISHLIST_DATA,
        payload: {
            manage: {
                data: formData,
                msgs: convertedMsgs
            }
        }
    };
}

export function submitCreateWishlist(data) {
    return {
        type: SUBMIT_CREATE_WISHLIST,
        payload: data
    };
}

export function submitCreateWishlistError(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: SUBMIT_CREATE_WISHLIST_ERROR,
        payload: {
            create: {
                msgs: payload
            }
        }
    };
}

export function submitDeleteWishlistError(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: SUBMIT_DELETE_WISHLIST_ERROR,
        payload: {
            'delete': payload
        }
    };
}

export function submitManageWishlistError(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: SUBMIT_MANAGE_WISHLIST_ERROR,
        payload: {
            create: payload
        }
    };
}

export function deleteWishlist(data) {
    return {
        type: DELETE_WISHLIST,
        payload: data
    };
}

export function wishlistAddToCart(data, e) {
    return {
        type: WISHLIST_ADD_TO_CART,
        payload: data,
        meta: {
            event: e
        }
    };
}

export function editWishlist(data) {
    return {
        type: EDIT_WISHLIST,
        payload: data
    };
}

export function removeDeleteWishlistError() {
    return {
        type: REMOVE_DELETE_WISHLIST_ERROR,
        payload: {}
    };
}

export function manageWishlistOpen(name) {
    return {
        type: MANAGE_WISHLIST_OPEN,
        payload: {
            manage: {
                name: name,
                opened: Date.now()
            }
        }
    };
}

export function manageWishlistClose() {
    return {
        type: MANAGE_WISHLIST_CLOSE,
        payload: {
            manage: {}
        }
    };
}

export function createWishlistOpen() {
    return {
        type: CREATE_WISHLIST_OPEN,
        payload: {
            create: {
                opened: Date.now()
            }
        }
    };
}

export function createWishlistClose() {
    return {
        type: CREATE_WISHLIST_CLOSE,
        payload: {
            create: {}
        }
    };
}

export function searchWishlistOpen() {
    return {
        type: SEARCH_WISHLIST_OPEN,
        payload: {
            search: {
                opened: Date.now(),
                showResults: false
            }
        }
    };
}

export function searchWishlistClose() {
    return {
        type: SEARCH_WISHLIST_CLOSE,
        payload: {
            search: {}
        }
    };
}

export function searchWishlistData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: SEARCH_WISHLIST_DATA,
        payload: {
            search: {
                data: formData,
                msgs: convertedMsgs,
                showNoValuesError: false
            }
        }
    };
}

export function noFieldsHaveValuesError() {
    return {
        type: NO_FIELDS_HAVE_VALUES_ERROR,
        payload: {
            search: {
                showNoValuesError: true
            }
        }
    };
}

export function submitSearchWishlistError(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: SUBMIT_SEARCH_WISHLIST_ERROR,
        payload: {
            search: {
                msgs: payload
            }
        }
    };
}

export function searchWishlistResults(results) {
    return {
        type: SEARCH_WISHLIST_RESULTS_DATA,
        payload: {
            search: {
                showResults: true,
                results: results
            }
        }
    };
}

export function searchWishlistHideResults() {
    return {
        type: SEARCH_WISHLIST_HIDE_RESULTS,
        payload: {
            search: {
                showResults: false,
                results: []
            }
        }
    };
}
